export default __webpack_public_path__ + "static/media/16_Erin.f52e9d09.mp3";